import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    panel: {
      footer: 'p-4 b-t b-grey-70',
      header: 'subtitle-2 p-4 b-b b-grey-70',
      wrapper: 'p-4'
    },
    modal: {
      header: 'subtitle-2',
    }
  },
  closeIconSize: 'md'
} satisfies RecursivePartial<VfConfig['dialog']>
